import useEnv from "./useEnv";
import useI18n from "./useI18n";

/**
 * Custom hook for localizing links.
 */
const useLocalizedLink = () => {
    const { getEnv } = useEnv();
    const { getLocale } = useI18n();

    /**
     * Parse a multi-locale link variable and return the link for the current locale.
     * Env. variable example: "FI:https://fi.example.com||SV:https://sv.example.com||EN:https://en.example.com||NO:https://no.example.com"
     * 
     * @param {string} envVariable env. variable to localize (multi-locacle link)
     * @returns {string|undefined} localized link | undefined
     */
    const getLocalizedLink = (envVariable) => {
        const variable = getEnv(envVariable);

        if (!variable) {
            return undefined;
        }

        const locale = getLocale().toUpperCase();
        // assume link is {LOCALE}:https://www.example.com/...
        const links = variable.split('||').map(link => link.split(':'));
        const found = links.find(([linkLocale]) => linkLocale.toUpperCase() === locale);

        return found ? found.slice(1).join(':') : undefined;
    }

    return {
        getLocalizedLink
    }
}

export default useLocalizedLink;